import { Box, CircularProgress } from "@material-ui/core";
import InflowScatterChart from "./InflowScatterChart";
import useInflowSeries from "../../../hooks/charts/useInflowSeries";

export default function InflowScatterChartContainer({
  parameterGroup,
  startDate,
  endDate,
  locationIds,
  height = 400,
}) {
  const { series, unit, parameter, isLoading, isError } = useInflowSeries({
    parameterGroup,
    startDate,
    endDate,
    locationIds,
  });

  if (isLoading) {
    return (
      <Box
        height={height}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isError || !series.length) {
    return (
      <Box
        height={height}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        No data
      </Box>
    );
  }

  return (
    <InflowScatterChart
      series={series}
      unit={unit}
      parameter={parameter}
      height={height}
    />
  );
}
